/**
 * @file   src\Pages\AddImageAdvertisement.tsx
 * @brief  AddImageAdvertisement page.
 * @date   JUL, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */

import { 
    React,
    useState, 
    useEffect, 
    Container, 
    Badge, 
    Button, 
    Breadcrumb, 
    Row, 
    Col, 
    useOutletContext, 
    useNavigate, 
    Form 
} from '../utils/thirdpartyComponents';
import "../styles/subscriptions.scss";
import CWSelect from '../components/CWSelect';
import CWInput from '../components/CWInput';
import { pageURLs } from '../utils/pageUrls'
import * as Yup from 'yup'
import { addSubscriptionSchema } from '../validations/addSubscriptionSchema';
import { AppContextType } from '../interfaces/generalInterface';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Fileimgicon from '../assets/images/photo-icon.svg';
import GenerateLink from '../components/GenerateLink';
import CarWashStatus from '../components/CarWashStatus';

const AddImageAdvertisement = () => {

    // State to handle locations given in dropdown
    const [locations, setLocations] = useState([
        { label: 'Location 1', value: '1' },
        { label: 'Location 2', value: '2' },
        { label: 'Location 3', value: '3' }
    ]);
    
    const [adtype, setadtype] = useState([
        { label: 'Video Adverstisement', value: '1' },
        { label: 'Image Adverstisement', value: '2' }
    ]);

    const handleDateChange = (setter: React.Dispatch<React.SetStateAction<Date | null>>) => (date: Date | null) => {
        setter(date);
    };

    const [startDate, setStartDate] = useState<Date | null>(null);
    const [endDate, setEndDate] = useState<Date | null>(null);

    // State to handle generated link
    const [generatedLink, setGeneratedLink] = useState('https://carwash-web.zcodemo.com/hoffman-car-wash/');

    // Initialize states for formdata
    const [formData, setFormData] = useState({
        location: [],
        subscription: '',
        washname: '',
        washdetails: '',
        washnumber: '1',
        amount: '',

    })

    // Initialise states for errors
    const [errors, setErrors] = useState({
        location: '',
        subscription: '',
        washname: '',
        washdetails: '',
        washnumber: '',
        amount: '',

    });


    // Access the context
    const { updateData } = useOutletContext<AppContextType>();

    const navigate = useNavigate()

    // To display heading
    useEffect(() => {
        handleUpdate()
    }, [])

    // Update the data
    const handleUpdate = () => {
        updateData({ heading: "Camps Car Wash", url: pageURLs.manage_subscriptions, showBackButton: true, showMainMenu: true, activeLink: "manage-car-wash" });
    };

    // Triggers on submit
    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault()
        try {
            if (formData.subscription === "single") {

                // In case of single type subscription washnumber is defaulted to 1
                formData.washnumber = "1"
            }
            // Validate form data
            await addSubscriptionSchema.validate(formData, { abortEarly: false });

            //Clear errors
            setErrors({
                location: '',
                subscription: '',
                washname: '',
                washdetails: '',
                washnumber: '',
                amount: '',
            });

            navigate(pageURLs.add_relaynumber)


        } catch (error) {
            // If validation fails on submit, then errors are shown
            if (error instanceof Yup.ValidationError) {
                const newErrors: any = {};
                error.inner.forEach((err) => {
                    newErrors[err.path as keyof typeof formData] = err.message;
                });
                setErrors(newErrors);
            }
        }
    }

    // Navigate accordung to url
    const itemClick = async (url: string) => {
        navigate(url);
    }

    return (

        <div className='manage-carwash-container manage-subscription-container'>
            <Container>
                <Breadcrumb>
                    <Breadcrumb.Item onClick={() => { itemClick(pageURLs.manage_carwash) }}>Manage Car Washes</Breadcrumb.Item>
                    <Breadcrumb.Item onClick={() => { itemClick(`${pageURLs.carwash_locations}/1`) }}  > Camps Car Wash</Breadcrumb.Item>
                    <Breadcrumb.Item onClick={() => { itemClick(pageURLs.manage_subscriptions) }}>Manage Advertisements</Breadcrumb.Item>
                    <Breadcrumb.Item active>Add New Image Advertisement</Breadcrumb.Item>
                </Breadcrumb>
                <div className="manage-activity-wrap d-flex justify-content-between align-items-center">
                   <GenerateLink/>
                 
                    <div className="activity-status d-flex">
                        <CarWashStatus carWashId={1} status={true} companyName={"abc"}/>
                        <div className="stat-group d-flex align-items-center">
                            <p>Subscription Status</p>
                            <Badge className='active'>Active</Badge>
                        </div>

                    </div>
                </div>
                <div className='cw-form-outer-wrap'>
                    <form onSubmit={(e) => handleSubmit(e)}>
                        <div className="cw-form-container">
                            <div className="form-inner mx-auto">
                                <Row>
                                    <Col md={6}>
                                        <CWSelect
                                            id="advertisementtype"
                                            name="advertisementtype"
                                            options={adtype}
                                            label="Avertisement Type"
                                            dropdownGap={0}
                                            dropdownPosition="auto"
                                            placeholder=""
                                            multi={false}
                                        />
                                    </Col>
                                    <Col md={6}>
                                        <CWSelect
                                            id="assignedlocation"
                                            name="assignedlocation"
                                            options={locations}
                                            label="Assigned Location"
                                            dropdownGap={0}
                                            dropdownPosition="auto"
                                            placeholder=""
                                            multi={false}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={6}>
                                        <CWInput
                                            id="advertisementname"
                                            name="advertisementname"
                                            type="text"
                                            label="Advertisement Name"
                                        />
                                        <Row>
                                            <Col md={6}>
                                                <div className="form-group date-space">
                                                    <p className="label">Valid From</p>
                                                    <DatePicker
                                                        showIcon
                                                        selected={startDate}
                                                        onChange={handleDateChange(setStartDate)}
                                                        placeholderText='MM/DD/YYYY'
                                                    />
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className="form-group date-space">
                                                    <p className="label">Valid To</p>
                                                    <DatePicker
                                                        showIcon
                                                        selected={endDate}
                                                        onChange={handleDateChange(setEndDate)}
                                                        placeholderText='MM/DD/YYYY'
                                                    />
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col md={6}>
                                        <div className="file-uploader-wrap">
                                            <div className="file-upload d-flex align-items-center justify-content-center">
                                                <div className="upload-info text-center">
                                                    <img src={Fileimgicon} alt="" />
                                                    <p className='f-semi'>Upload Image</p>
                                                    <span className="file-name">advertisement.jpg</span>
                                                </div>
                                                <Form.Control type="file" multiple className='file-input'/>
                                            </div>
                                            <span className="upload-note">Note: Accepted image formats are .jpeg and .png</span>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                        <div className="btn-sec d-flex justify-content-end">
                            <Button title="Cancel" variant="primary" className="secondary-btn" onClick={() => navigate(pageURLs.manage_subscriptions)}>Cancel</Button>
                            <Button title="Save" variant="primary" className="primary-btn" type="submit">Save</Button>
                        </div>
                    </form>
                </div>
            </Container>
        </div >
    )
}

export default AddImageAdvertisement;
